import Report from '@/models/Report'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    reportDetails: []
  },

  actions: {
    async getIncidentReports({ commit }, params) {
      try {
        const query = Report.page(params.page || 1)

        query.where('reportable_type', params.reportable_type)

        if (params.search) {
          query.where('search', params.search)
        }

        const res = await query
          .params({ limit: 20 })
          .include('reporter', 'reason')
          .get()

        commit('setIncidentReportList', res.data)
        commit('setIncidentReportListMeta', res.meta)
      } catch (error) {}
    },

    async getReportDetails({ commit }, reportId) {
      try {
        const { data } = await Api.get(
          `/admin/report/${reportId}?include=reason,reporter,attachments,reportable`
        )

        commit('setReportDetails', data.data)
      } catch (error) {}
    },

    async blockIncidentPost({ commit }, payload) {
      try {
        await Api.post(`/admin/incident/${payload.incident}/blocked`)
      } catch (error) {}
    },

    async unblockIncidentPost({ commit }, incidentID) {
      await Api.post(`/admin/incident/${incidentID}/blocked`)
    }
  },

  mutations: {
    setIncidentReportList(state, reports) {
      each(reports, report => {
        const exist = find(state.list, { id: report.id })
        if (!exist) {
          state.list.push(new Report(report))
        }
      })
    },

    clearIncidentReportList(state) {
      state.list = []
    },

    setIncidentReportListMeta(state, meta) {
      state.listMeta = meta
    },

    setReportDetails(state, report) {
      if (report instanceof Report) {
        state.reportDetails = report
      } else {
        state.reportDetails = new Report(report)
      }
    },

    clearReportDetails(state) {
      state.list = []
    }
  }
}
